<script setup lang="ts">
import { useField } from 'vee-validate'

const originalProps = defineProps<{
  name: string
  disabled?: boolean
  label?: string
  items?: any[]
  tooltip?: any
  disableStoryblok?: boolean
}>()
const emit = defineEmits(['changed'])
const ga4 = useAnalytics()
const props = originalProps.disableStoryblok ? originalProps : useStoryblokProps(originalProps)
const { value: modelValue } = useField<boolean | string>(props.name, undefined, {
  type: 'radio',
})

function clickEvent(selectedValue: string) {
  modelValue.value = selectedValue
  emit('changed', selectedValue)
  ga4.trackEvent({
    event_action: 'radio',
    event_label: originalProps?.name,
  })
}
</script>

<template>
  <div>
    <BaseLabel v-if="props.label" :tooltip="props.tooltip">
      {{ props.label }}
    </BaseLabel>
    <div class="border-1 border-form shadow-form rounded-xl flex items-center justify-between items-stretch">
      <template v-for="{ text, value, icon } in props.items" :key="value">
        <div
          class="<xs:px-0 p-1 -m-px border-2 border-transparent rounded-xl group cursor-pointer w-auto flex items-center not-last:w-full"
          :class="{ '!border-primary bg-primary/15 z-1': modelValue === value }"
          :data-test-id="`FieldRadioPill|${name}|${value}`"
          @click="clickEvent(value)"
        >
          <div
            class="xs:px-1 sm:px-2 md:px-5 py-1 rounded-lg flex w-full gap-2 justify-center text-center items-center"
            :class="{ 'group-hover:bg-primary/15 group-hover:h-full group-hover:text-hover': modelValue !== value }"
          >
            <AppIcon v-if="icon?.icon" v-bind="icon" size="16" />
            <span>{{ text }}</span>
          </div>
        </div>
        <span class="not-last:h-6 not-last:self-center not-last:border-r-1 not-last:border-gray" />
      </template>
    </div>
  </div>
</template>
